import { CheckIcon, ChevronDown } from "lucide-react";
import { useState } from "react";
import AnimateHeight from "react-animate-height";
import { useNavigate } from "react-router-dom";

import { Models } from "@/api/types";
import { Text } from "@/atoms";
import { AvailableReward } from "@/molecules/containers/reward/available-reward/AvailableReward";
import { useFeatureFlag } from "@/services/Flags";

export type AwardedReferralRewardsListProps = {
  awardedReferralRewards?: Models<"DisplayRedeemableReferralReward">[];
};

export const AwardedReferralRewardsList = ({
  awardedReferralRewards = [],
}: AwardedReferralRewardsListProps) => {
  const referralRewardPhase2 = useFeatureFlag("referral-rewards-phase-2");
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  if (!awardedReferralRewards?.length || !referralRewardPhase2) {
    return null;
  }

  const handleRewardNavigation = (legacyRewardId: string) => {
    const url = `/rewards/${legacyRewardId}`;
    navigate(url);
  };

  return (
    <div className="flex flex-col">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex justify-between border-b border-t px-4 py-4 text-start text-sub2 text-black transition-colors hover:bg-gray-50"
      >
        <Text
          className="text-start text-sub2 uppercase text-black"
          text="Awarded Referral Rewards"
          variant="h2"
        />
        <ChevronDown
          className={`h-5 w-5 text-gray-600 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>
      <AnimateHeight
        height={isOpen ? "auto" : 0}
        duration={300}
        easing="ease-in-out"
      >
        <div className="flex flex-col gap-2 bg-white">
          {awardedReferralRewards.map((reward, index) => {
            const hasLegacyRewardId = reward.legacyRewardId;

            const clickHandler = reward.legacyRewardId
              ? () => handleRewardNavigation(reward.legacyRewardId as string)
              : undefined;

            let tagDescription = hasLegacyRewardId ? "REDEEM" : "BANKED";

            if (reward.awardedReferralReward.isBonus) {
              tagDescription = "REDEEM BONUS";
            }
            return (
              <div
                key={
                  reward.awardedReferralReward.referralRewardAtTheTime
                    .referralRewardId + index
                }
                className="border-b border-background-two transition-[translate] duration-500"
              >
                <AvailableReward
                  id={
                    reward.awardedReferralReward.referralRewardAtTheTime
                      .referralRewardId
                  }
                  title={
                    reward.awardedReferralReward.isBonus
                      ? reward.awardedReferralReward.referralRewardAtTheTime
                          .bonusRewardTitle?.text
                      : reward.awardedReferralReward.referralRewardAtTheTime
                          .rewardTitle?.text
                  }
                  onClick={clickHandler}
                  tagDescription={tagDescription}
                  icon={hasLegacyRewardId ? undefined : CheckIcon}
                />
              </div>
            );
          })}
        </div>
      </AnimateHeight>
    </div>
  );
};
